import { Card } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { soldoutInCustompageList_soldoutInCustompage_edges_node } from "@saleor/soldoutcustompage/types/soldoutInCustompageList";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Container from "../../../components/Container";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  TabPageProps
} from "../../../types";
import SoldoutCustomPageList from "../SoldoutCustomPageList/SoldoutCustomPageList";
import {
  createFilterStructure,
  SoldoutCustomPageFilterKeys,
  SoldoutCustomPageListFilterOpts
} from "./filters";

export interface SoldoutCustomPageListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<
      SoldoutCustomPageFilterKeys,
      SoldoutCustomPageListFilterOpts
    >,
    TabPageProps {
  soldoutCustomPages: soldoutInCustompageList_soldoutInCustompage_edges_node[];
  toatlCount: number;
  onBack: () => void;
}
const SoldoutCustomPageListPage: React.FC<SoldoutCustomPageListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();

  const structure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader
        title={
          intl.formatMessage(sectionNames.soldoutcustompage) +
          "(" +
          toatlCount +
          ")"
        }
      ></PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Soldout CustomPage",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search SoldoutCustomPage"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <SoldoutCustomPageList {...listProps} />
      </Card>
    </Container>
  );
};
export default SoldoutCustomPageListPage;
